import React, { useRef } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import "./tableDashBoard.scss";

export default function TableDashBoard({
    isClickable = false,
    titleList,
    data,
    isJDPage = false,
}) {
    const navigate = useNavigate();
    const inputRef = useRef(null);
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const parentPath = pathSegments[1];
    if (!data) {
        return (      
              <div style={{ textAlign:"left",margin: "50px" ,fontSize: "12px"}} >
                No updates in the selected duration
              </div>
              )
    }

    const GetJobID =(title)=> {
        const jd_array = title?.split(']')
        var jdID = jd_array[0]?.replace("[", "");
        return jdID
    }
    const handleJDClick = (id) => {
    navigate(`/${parentPath}/${id}`);
    };
   const handleResumeStatsClick = (id)=>{
    navigate(id)
   }
   
    return (
        <div className="table-dashboard-wrapper">
            <div
                className="table-title-wrapper"
                style={{
                    gridTemplateColumns: `50px 1fr 1fr 3fr 1fr 1fr 1fr repeat(${titleList.length-7}, 1fr)`
                }}
            >
                {titleList.map((title) => (
                    <div className="table-title">{title}</div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    onClick={isJDPage ? () => handleJDClick(GetJobID(table.title)) : () => handleResumeStatsClick(table.team_member_id ) }
                    key={table.id}
                    className="table-info-wrapper"
                    style={{
                        gridTemplateColumns: `50px 1fr 1fr 3fr 1fr 1fr 1fr repeat(${titleList.length-7}, 1fr)`,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="table-info">
                            {   <>
                                {tableInfo === "id"
                                    ? rowIndex + 1
                                    : table[tableInfo]}
                                </>}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
